import React from 'react'

const muiNe = {
    id: 'mui-ne',
    type: 'post',
    countryId: 'seAsia',
    title: 'Sun and Sand in Mui Ne',
    longDate: 'November 18, 2018',
    month: 'Nov',
    date: '18',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/MuiNeCover.jpg',
    content: [
        {
            text: (
                <div>"Mui Ne is the most Russian place I've ever been." So read an Instagram caption from a backpacker visiting the town, and if I hadn't been to Russia itself, I would agree. It's like Cabo for Americans or Ibiza for Brits: an easily reached vacation spot summed-up by cocktails on a beach, and no judgment.</div>
            )
        },
        {
            text: (
                <div>We'd been in Saigon a couple of weeks and were starting to feel a little antsy about being in a concrete jungle for so long, so decided with a couple of days notice to go out to Mui Ne. There are a few options for how to get there: motorbike (beautiful road, but you’d get a sore bum from 5-6 hours), private car (again 5-6 hours on an ill-maintained road), or the obvious choice: the train!</div>
            )
        },
        {
            text: (
                <div>The train takes only 4 hours and was, a bit surprisingly, both a smooth ride and a clean, comfortable experience. A quirky feature of busses and trains in Vietnam is the on-board entertainment: music videos and taped live recordings of musical shows, with the volume blasted LOUD for everyone's viewing pleasure. (They are pretty funny sometimes, but still.) Luckily, after about 2 hours of this they switched the channel to a polar nature expedition and turned off the sound.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/screen.png'
        },
        {
            text: (
                <div>At the train station in Phan Thiet, we saw a pair of backpackers and offered to split the taxi ride to the resort area with them. I had thought Mui Ne would be a compact, walkable town, but it's actually miles and miles of guesthouses and shops spread along an oceanside road. We asked the driver to drop us off at a lunch spot, and ordered a delicious fish dish off a menu in Cyrillic and English, baked in a clay pot with a sticky sweet sauce.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/fishdish.png'
        },
        {
            text: (
                <div>After checking into our guesthouse, we were feeling a little tired from the early morning wake-up and headed across the street to Le Miracle Chill & Grill for a cold drink and chairs to relax and read on. After a few hours, we hit a crossroads: to get up, rent a motorbike, and drive out to the sand dunes for sunset, or... keep drinking on the beach? I think you know what we picked.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/LeMiracle.jpg',
            detailText: 'Le Miracle Chill & Grill, where we spent the entire afternoon our first day.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/LeMiracle2.jpg'
        },
        {
            text: (
                <div>Around 6, Peter got hungry for a snack and we wandered down the street looking for food. We found a counter where a very tan Swede was selling cheesy, meaty sandwiches (Peter's three favorite food groups.) As we went to find a table, we discovered that the sandwich stand was just one of many counters in an outdoor food hall. There was a central bar, an Indian place, a vegetarian place, tapas, a couple of Vietnamese places, and dozens of Russian tourists sitting down to pre-dinner drinks and snacks. The place was a paradise for delicious food and drinking cheap beer by twinkle lights. We stayed until 11, went back for breakfast and dinner the next day, and breakfast again the third day. Please, if you go to Mui Ne, stay near Dong Vui Food Court and get the soon-to-be-world-famous Eggs Benedict.</div>
            )
        },
        {
            text: (
                <div>After our divine breakfast the next day, we rented a motorbike from the guesthouse and headed out to Ta Cu mountain. We didn't know much about it other than that the monastery at the top had a large white Buddha. On arrival we found a very empty "TC WORLD" theme park – basically just large sculpted gardens with statues and a gondola up to the monastery. The other place we'd encountered an eerily empty, recently developed park surrounding a tourist attraction was at Ho Thang Hen, an hour from Cao Bang. Our best theory is the "if you build it, they will come" model – but most tourists aren't willing to drive a motorbike an hour down the Wild West potholed highways to get to these attractions. Maybe as tourism increases in Vietnam, the spots will become more popular, but I doubt so without serious investment in the roads and infrastructure to make them accessible.</div>
            )
        },
        {
            text: (
                <div>In any case, it was cool to take the gondola up and over dense, overgrown jungle with a view across farmlands. We shared the gondola with a Belarussian couple and their extremely excited four-year-old son who babbled in Russian about the trees and sea. I remembered again how terrible my Russian is now, since I could barely understand a child and definitely couldn't understand the full sentences from his parents. Must get back on Duolingo.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/TaCu.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Buddha1.jpg',
            detailText: 'A pretty big Buddha...'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Buddha2.jpg',
            detailText: 'A REALLY big Buddha.'
        },
        {
            text: (
                <div>We didn't get back for lunch until nearly 3, and immediately turned around to head out to the sand dunes. On the way we stopped at "Fairy Stream." A lot of blogs had mentioned it as a cool hidden spot, and it was definitely pretty, but after Iceland it's hard to get too excited about the waterfalls and streams here.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/FairyStream.jpg',
        },
        {
            text: (
                <div>There are two main locations to see the sand dunes in Mui Ne. One is called the White Sand Dunes, and the other the Red Sand Dunes. We went to the red dunes, haggled with a woman for a plastic sandboard, and walked up to the top in golden hour. It was beautiful, and we walked around looking for the best spot to take photos, like every other tourist (sorry not sorry.) Peter released his inner child with the sandboard, and also made an amazing photo fail.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/PeterFallingPhoto.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/sandsurfing.gif'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Sand-Alice.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Sand-Peter.jpg'],
            detailText: 'Probably should have asked someone to take a photo of us together, but I love these anyway.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Dunes1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Dunes2.jpg'
        },
        {
            text: (
                <div>On our last morning, we took a long beach walk to work off our Eggs Benedict and watched a mixture of beachgoers and fisherman mingle on the thin strip of sand. Before the trip, I had been feeling really antsy – deprived of nature, sick and stuck in bed or the chiropractor's office for most of the time, and generally unhappy for the first time since we left to travel. After three days of beautiful weather, great food, and lots of relaxation and reading, I was back to normal and ready to explore Saigon. A piña colada on the beach can never go wrong.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Beach1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/MuiNe/Beach2.jpg',
        }
    ]
}

export default muiNe


// WEBPACK FOOTER //
// ./src/Posts/Content/MuiNe.js